import ADPCustService from "../../../services/admin/ADPCustService";
import ADPDeptService from "../../../services/admin/ADPDeptService";
import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";
import GEOCtryService from "../../../services/geo/GEOCtryService";
import GEODistService from "../../../services/geo/GEODistService";
import GEOPostService from "../../../services/geo/GEOPostService";
import GEOStateService from "../../../services/geo/GEOStateService";

class customerService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAllCust(): Promise<any> {
        return await ADPCustService.findAll();
    }

    async create(data: any): Promise<any> {
        return await ADPCustService.create(data);
    }

    async update(id: any, data: any): Promise<any> {
        return await ADPCustService.update(id, data);
    }

    async getStateDropdown(countryCode: any): Promise<any> {
        return await GEOStateService.getDropdownByCountryCode(countryCode);
    }

    async getCountryDropdown(): Promise<any> {
        return await GEOCtryService.getCountryDropdown();
    }

    async getDistrictDropdown(stateCode: string): Promise<any> {
        return await GEODistService.getDropdownByCountryCodeAndStateCode('MYS',stateCode);
    }

    async getPostcodeDropdown(stateCode: string): Promise<any> {
        return await GEOPostService.getDropdownByStateCode(stateCode);
    }

    async getDeptDropdown(): Promise<any> {
        return await ADPDeptService.getDropdown();
    }

    async getCustTypeDropdown(referenceGroup: string, moduleId: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

}

export default new customerService();
